import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import logo from '../Media/android-chrome-512x512.png';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <img src={logo} alt="Innovative Horizons" className="footer-logo" />
          <p className="footer-copy">{t.footer.about}</p>
        </div>

        <div>
          <h4>{t.footer.services}</h4>
          <div className="footer-links-list">
            {t.footer.serviceLinks.map((item) => (
              <Link key={item.to} to={item.to}>{item.label}</Link>
            ))}
          </div>
        </div>

        <div>
          <h4>{t.footer.contact}</h4>
          <div className="footer-links-list">
            <a href="mailto:contacto@innovativehorizonseua.com">contacto@innovativehorizonseua.com</a>
            <Link to="/contact">{t.footer.requestAdvice}</Link>
            <Link to="/portfolio">{t.footer.viewPortfolio}</Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>© 2026 Innovative Horizons</span>
          <span>{t.common.rights}</span>
        </div>
      </div>
    </footer>
  );
}
